webpackJsonp([16],{

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processPayment1_vue__ = __webpack_require__(1121);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09507ea4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processPayment1_vue__ = __webpack_require__(1234);
function injectStyle (ssrContext) {
  __webpack_require__(1232)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processPayment1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09507ea4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processPayment1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_constant_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_constant_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_constant_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      paymentID: 0,
      BASEURL: __WEBPACK_IMPORTED_MODULE_3__helper_constant_js__["URL_BASE"],
      successURL: window.location.origin + "/confirmBooking",
      failedURL: window.location.origin + "/failedPayment",
      url: __WEBPACK_IMPORTED_MODULE_3__helper_constant_js__["EVENT_URL"]
    };
  },
  beforeMount: function beforeMount() {
    // this.showLoading();
    var paymentID = this.$route.params.paymentID;

    this.paymentID = paymentID;
    this.checkPayment();
    // window.location.href =
    //   `${this.BASEURL}/FinalBooking?PaymentGatewayID=` +
    //   this.paymentID +
    //   `&ApiCallURL=${this.BASEURL}` +
    //   `&SucessUrl=${this.successURL}` +
    //   `&FailUrl=${this.failedURL}`;
  },
  mounted: function mounted() {},

  methods: {
    checkPayment: function checkPayment() {
      var _this = this;

      var url1 = this.paymentID === "undefined" ? "/v1/payment/reserve-check-payment/" + this.$cookies.get("reseverID") : "/v1/payment/check-payment/" + this.paymentID;
      console.log("url", this.url + url1);
      Object(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__["makeRequest"])(url1, "GET", null, null, this.url).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data) {
          if (!error) {
            console.log(res.data);
            if (res.data.pg_response) {
              if (res.data.pg_status == "success") {
                if (res.data.book_type == "movie") {
                  _this.$router.push("/confirmBooking/" + res.data.booking_id);
                } else {
                  _this.$router.push("/payment-completed/" + res.data.booking_id);
                }
              } else if (res.data.pg_status == "cancel") {
                _this.$router.push("/payment-cancelled/" + res.data.order_id);
              } else {
                // payment-cancelled/1474
                _this.$router.push("/payment-failed/" + res.data.order_id);
              }
            } else {
              var that = _this;
              setTimeout(function () {
                that.checkPayment();
              }, 2000);
            }
            // if (
            //   res.data.Status == false &&
            //   res.data.BookStatus == "pending"
            // ) {
            //   let that = this;
            //   setTimeout(function () {
            //     that.checkPayment();
            //   }, 2000);
            // } else if (
            //   res.data.Status == true &&
            //   res.data.BookStatus == "booked"
            // ) {
            //   this.$router.push("/confirmBooking/" + res.data.Message);
            // } else {
            //   this.$router.push("/failedPayment");
            // }
          }
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),

/***/ 1232:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1233);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1036)("b84fd1a0", content, true, {});

/***/ }),

/***/ 1233:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1035)(true);
// imports


// module
exports.push([module.i, ".sbcls{width:100px;height:100px;margin-top:100px}", "", {"version":3,"sources":["/var/www/html/cineco/website/vue-pwa-initial-setup/src/components/pages/processPayment1.vue"],"names":[],"mappings":"AACA,OACE,YAAa,AACb,aAAc,AACd,gBAAkB,CACnB","file":"processPayment1.vue","sourcesContent":["\n.sbcls {\n  width: 100px;\n  height: 100px;\n  margin-top: 100px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center error-container"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"faipay-fs"},[_vm._v("Processing request please wait ..!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/16.4584066c94c557b61a25.js